import { render, staticRenderFns } from "./Gain3View.vue?vue&type=template&id=d04f72ce&scoped=true"
import script from "./Gain3View.vue?vue&type=script&lang=js"
export * from "./Gain3View.vue?vue&type=script&lang=js"
import style0 from "./Gain3View.vue?vue&type=style&index=0&id=d04f72ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04f72ce",
  null
  
)

export default component.exports